import "./FAQ.module.css";
import Header from "@/reusable_sections/Header";
import RemodelingFaq from "./sections/RemodelingFaq";
import ClosingConsultation from "./sections/ClosingConsultation";
import Footer from "@/reusable_sections/Footer";
export default function FAQPage() {
  return <div>
      <Header />
      <RemodelingFaq />
      <ClosingConsultation />
      <Footer />
    </div>;
}